<template>
  <section>
    <div class="form-content">

      <!-- <el-col :span="12"> -->
      <!-- </el-col> -->
      <div class="clear">
        <el-col :span="12" v-if="form.type==0">
          <el-form-item label="申请部门">
            <el-input size="small" :disabled="true" v-model="userData.childDept"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-else>
          <el-form-item label="申请单位">
            <el-input size="small" :disabled="true" v-model="userData.department.split('/')[0]"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="申请人">
            <el-input size="small" :disabled="true" v-model="userData.name"></el-input>
          </el-form-item>
        </el-col>
      </div>
      <el-form-item label="供应商名称">
        <el-input size="small" v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="采购货物名称">
        <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8}" size="small" v-model="form.productName">
        </el-input>
        <!-- <el-input size="small" v-model="form."></el-input> -->
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 6}" size="small" v-model="form.remark"></el-input>
        <!-- <el-input size="small" v-model="form."></el-input> -->
      </el-form-item>

    </div>
  </section>

</template>
<script>
  export default {
    props: ['formByFather', 'userData', 'type'],
    data() {
      return {
        form: {},
        // 选择项目列表
        projectList: [],

        addType: 0,
        editIndex: '',
        mform: {
          name: '',
          spec: '',
          price: '',
          amount: 1,
          fee: '',
          ghdw: '',
        },
        zbfsArr: ["单一来源", "竞争性谈判", "邀请招标", "公开招标"],

        addStatus: false,
        userDeptId: "",
      }
    },
    created() {},
    mounted() {
      this.form = this.formByFather

      // 获取项目列表
      // this.getProjectList(() => {

      // })
    },
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      // 获取项目列表
      // getProjectList(cb) {
      //   ajax.get('/contract/project/choose/list', {
      //     depId: ''
      //   }, (res) => {
      //     this.projectList = res.vo.array
      //     cb && cb()
      //   })
      // },
      // 通过项目ID获取项目Name
      // getProjectNameById() {
      //   let name = []
      //   for (let i = 0; i < this.form.projectIds.length; i++) {
      //     let _id = this.form.projectIds[i]
      //     for (let j = 0; j < this.projectList.length; j++) {
      //       if (this.projectList[j].id == _id) {
      //         name.push(this.projectList[j].name)
      //         break
      //       }
      //     }
      //   }
      //   return name.join(",")
      // },

      // 编辑采购项目
      MaterialChange(row, index) {
        this.addType = 1
        this.editIndex = index
        this.mform = row
        this.addStatus = true
      },
      // 从列表里删除当前采购项目
      MaterialDelete(index) {
        this.form.purchaseRecordItems.splice(index, 1)
      },
      // 显示添加采购项目弹窗
      AddMaterial() {
        // 初始化
        this.mform = {
          name: '',
          spec: '',
          price: '',
          amount: 1,
          fee: '',
          ghdw: '',
        }
        this.addType = 0
        this.addStatus = true
      },
      // 添加采购项目到列表
      AddBtnClick() {
        if (!this.mform.name || !this.mform.price || !this.mform.amount) {
          this.$message.error("请认真填写采购信息，带*为必填项")
          return
        }
        if (this.addType == 0) {
          this.form.purchaseRecordItems.push(this.mform)
        } else {
          this.form.purchaseRecordItems.splice(this.editIndex, 1, this.mform)
        }
        this.addStatus = false

        this.fixedTotalPrice()
      },
      // 返回form
      getFromData() {
        // this.form.projectNames = this.getProjectNameById()
        return this.form
      },
      // 计算某项目总价
      fixedFee() {
        if (this.mform.price && this.mform.amount) {
          this.mform.fee = (this.mform.price * this.mform.amount).toFixed(2)
        }
      },
      // 计算真实总价
      fixedTotalPrice() {
        let _total = 0
        for (var i = 0; i < this.form.purchaseRecordItems.length; i++) {
          _total += parseFloat(this.form.purchaseRecordItems[i].fee)
        }
        this.form.priceNum = _total.toFixed(2)
        this.form.price = util.convertCurrency(this.form.priceNum)
      },
    },
    watch: {
      "mform.price"() {
        this.fixedFee()
      },
      "mform.amount"() {
        this.fixedFee()
      },
      formByFather() {
        this.form = this.formByFather
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/purchase/supplier.vue